import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { StationHours } from '@app/services/station.interface';
import { daysOfWeek } from '@app/shared/utils/consts';
import { IHours } from '@app/shared/utils/station-hour';

@Component({
  selector: 'app-add-missing-charger-hours-edit-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatLabel],
  templateUrl: './add-missing-charger-hours-edit-dialog.component.html',
  styleUrl: './add-missing-charger-hours-edit-dialog.component.scss'
})
export class AddMissingChargerHoursEditDialogComponent {
  dialogRef = inject(MatDialogRef<AddMissingChargerHoursEditDialogComponent>);
  hours: IHours[];
  weekdays = daysOfWeek;
  selectedWeekdays = [];
  isOpen24Hours = false;
  isClosed = false;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { hours: StationHours, days: string[] }
  ) {
    this.selectedWeekdays = data.days;
    if (data.days.length > 1) {
      this.hours = [
        {
          day: daysOfWeek.indexOf(data.days[0]),
          open: '',
          close: '',
        }
      ];
    } else {
      this.hours = data.hours.dayHours[data.days[0]] as any;
      this.isOpen24Hours = data.hours.open24Hours;
    }
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    const newHours = {};
    if (this.isClosed) {
      this.selectedWeekdays.forEach((day) => {
        newHours[day] = [{}];
      });
    } else {
      this.selectedWeekdays.forEach((day) => {
        newHours[day] = this.hours.map(hour => ({
          ...hour,
          open: hour?.open,
          close: hour?.close,
          day: daysOfWeek.indexOf(day),
        }));
      });
    }

    const finalHours: StationHours = {
      dayHours: {
        ...this.data.hours.dayHours,
        ...newHours,
      },
      open24Hours: this.isOpen24Hours,
    };

    this.dialogRef.close({
      hours: finalHours,
    });
  }

  onDayChange(weekday: string) {
    if (this.selectedWeekdays.includes(weekday)) {
      this.selectedWeekdays = this.selectedWeekdays.filter(day => day !== weekday);
    } else {
      this.selectedWeekdays.push(weekday);
    }
  }

  addHours() {
    this.hours.push({
      day: this.selectedWeekdays[0],
      open: '',
      close: '',
    });
  }

  removeHours(index: number) {
    this.hours.splice(index, 1);
  }

  updateValue(hour: IHours, key: "open" | "close", event: any) {
    const index = this.hours.indexOf(hour);
    this.hours[index] = { ...hour, [key]: event.target.value };
  }
}
